import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '../../shared/mhx/mhx-tokens.css'
import './styles/mhx-layout.css'
import './styles/mhx-element.css'
import App from './App.vue'
import router from './router'
import { installPermissionDirective } from '@/utils/permissions'

Vue.use(ElementUI)
installPermissionDirective(Vue)
Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
